import { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { useLocation, useNavigate } from "react-router-dom";
import { joinUsers, loginUser , joinORcancel } from "../../types/Reievespf003";
import { eventInfo, attachments , joinInfo} from '../../types/common';
import { Header } from "../../components/common/Header";
import { EventDetail } from "../../components/event/EventDetail";
import { JoinUsersList } from "../../components/event/JoinUsersList";
import { Footer } from "../../components/common/Footer";
import { useAsyncEffect } from "../../helper/hooks/async-hooks";
import { getEventDetailInfo } from "../../components/event/getEventDetailInfo";
import { getEventJoinUsers } from "../../components/event/getJoinUsers";
import { getLoginName } from "../../components/event/getLoginName";
import { getJoinStatus } from "../../components/event/getJoinStatus";
import { setCancel } from "../../components/event/setCancel";
import { setJoin } from "../../components/event/setJoin";
import { MailSendedModal } from "../../components/event/MailSendedModal";
import { getCancelwaitUsers } from '../../components/event/getCancelwaitUsers';
import { getEventAttachments } from '../../components/event/getEventAttachments';
import { setCancelWaiting } from "../../components/event/setCancelWaiting";
import { setNotJoin } from "../../components/event/setNotJoin";
import { CancelWaitUsersList } from "../../components/event/CancelwaitUsersList";


/**
 * イベント詳細画面
 */
export function Reievespf003(){
    const navigate = useNavigate();

    //  アカウントIDを保存するcookie
    const [cookieAccId, setCookieAccId, removeCookieAccId] = useCookies(['idCookie']);
    //  対応会員番号を保存するcookie（秘書の場合のみ）
    const [cookieSecAccId, setCookieSecAccId, removeCookieSecAccId] = useCookies(['secIdCookie'])
    //  ロータリーCDを保存するcookie
    const [cookieRotaryCd, setCookieRotaryCd, removeCookieRotaryCd] = useCookies(['rotaryCookie'])

    //  イベント詳細情報を保持するstate
    const [eventInfo, setEventInfo] = useState<eventInfo>();

    //  参加予定の会員情報を保持するstate
    const [joinUsers, setJoinUsers] = useState<joinUsers[]>([]);

    //  ログイン者の氏名を保持するstate
    const [loginName, setLoginName] = useState<loginUser>();

    //  モダールの表示状態を保持するstate
    const [isModal, setIsModal] = useState<joinORcancel>({modal:false,joinORcancel:true});

    //  参加可否を保持するstate
    const [joinInfo, setJoinInfo] = useState<joinInfo>({joinFlag:null,cancel_waiting_flag:null});

    //  申込期限日時を保持するstate
    const [limit, setLimit] = useState<boolean>(false);
    
    //  メール送信完了の状態を保持するstate
    const [isSend, setIsSend] = useState<boolean>(false);

    //  超過フラグの状態を保持するstate
    const [isMore, setIsMore] = useState<boolean>(false);

    //  API呼び出し時のパラメータに設定するアカウントIDを保持するstate
    const [paramId, setParamId] = useState<string>("");

    //  詳細画面の開閉状態を保持するstate
    const [isDetail,setIsDetail] = useState<boolean>(true);

    //　キャンセル待ち登録の会員情報を保持するstate
    const [cancelWaitingUsers, setCancelWaitingUsers] = useState<joinUsers[]>([]);

    //　添付ファイルを保持するstate
    const [attachments, setAttachments] =useState<attachments[]>([]);

    //　直前での期限切れ、あるいは枠埋まったなどによる登録エラーを保持するstate
    const [isError, setIsError] =useState<boolean>(false);


    //  クエリパラメータからイベントURLを取得
    const query = new URLSearchParams(useLocation().search)
    const eventUrl = query.get('url')|| '';

    //  ログイン者のアカウントID
    const loginId = cookieAccId.idCookie;

    useAsyncEffect(async () => {
        if(eventUrl !== ''){
            //  イベント詳細
            const eventDetail = await getEventDetailInfo({
                eventUrl: eventUrl,
                rotaryCd: cookieRotaryCd.rotaryCookie
            });
            setEventInfo(eventDetail)

            //  イベント詳細情報が取得できない場合、マイページに遷移
            if (Object.keys(eventDetail).length === 0) {
                navigate('/mypage')
                return;
            }

            //  参加予定の会員
            setJoinUsers(await getEventJoinUsers({
                eventUrl: eventUrl,
                rotaryCd: cookieRotaryCd.rotaryCookie
            }));

            //　キャンセル待ち登録の会員
            setCancelWaitingUsers(await getCancelwaitUsers({
                eventUrl: eventUrl,
                rotaryCd: cookieRotaryCd.rotaryCookie
            }));

            //　添付ファイル取得
            setAttachments(await getEventAttachments({
                eventUrl: eventUrl,
                rotaryCd: cookieRotaryCd.rotaryCookie
            }));

            let id;

            //  対応会員番号を取得できた場合、パラメータに設定
            if(cookieSecAccId. secIdCookie != null){
                id = cookieSecAccId.secIdCookie
                setParamId(id);
            }else{
                id = cookieAccId.idCookie
                setParamId(id);
            }

            //  ログイン者の氏名（秘書の場合は対応会員の氏名）
            setLoginName(await getLoginName({
                id: id,
                rotaryCd: cookieRotaryCd.rotaryCookie
            }))

            //  参加可否
            setJoinInfo(await getJoinStatus({
                accountId: id,
                eventUrl: eventUrl,
                rotaryCd: cookieRotaryCd.rotaryCookie
            }))
        }
    },[])

    useEffect(() => {
        //  現在日時
        let currentDateTime = new Date();

        const strLimitTime = eventInfo?.limit_time;
        var strLimitDate = new Date(eventInfo?.limit_date + '').toLocaleDateString();
        var limitDate = new Date(strLimitDate)

        if(limitDate && strLimitTime){
            //  hh:mm:ss
            const splitLimitTime = strLimitTime?.split(':')

            //  年月日をそれぞれ取得
            var limitHour = splitLimitTime[0]
            var limitMinute = splitLimitTime[1]
            var limitSecond = splitLimitTime[2]

            //  申込期限日に申込期限時刻を加算
            limitDate.setHours(limitDate.getHours() + Number(limitHour))
            limitDate.setMinutes(limitDate.getMinutes() + Number(limitMinute))
            limitDate.setSeconds(limitDate.getSeconds() + Number(limitSecond))

            //  現在日時と比較し、申込期限を過ぎている場合
            if(limitDate < currentDateTime){
                setLimit(true)
            }
        }

    },[eventInfo?.limit_date, eventInfo?.limit_time])


    //  モーダルの表示切替
    const changeModal = (props:joinORcancel) => {
        setIsModal({
            modal:props.modal,
            joinORcancel:props.joinORcancel,
        })
    }

    //詳細モーダルの表示切替
    const changeDetail = (status:boolean)=>{
        setIsDetail(status)
    }

    //  ボタン押下時
    const onClickButton = async() => {
        if(joinInfo.joinFlag){
            //参加登録時
            if( limit ){
                // 期限切れ（キャンセル登録）
                onClickLimitCancelButton();
            }else{
                if( Number(eventInfo?.join_num) >= Number( eventInfo?.limit_member )  ){
                    //人数超過（キャンセル登録）
                    onClickCancelButton();
                }else{
                    //期限内、定員内（不参加登録）               
                    onClickUnJoinButton();
                }
            }
        }else{
            //不参加登録時
            if( !joinInfo.cancel_waiting_flag &&  limit ){  
                //キャンセル待ちをしてない　かつ　期限切れ 
                onClickLimitCancelWaitingButton();
            }else if ( !joinInfo.cancel_waiting_flag && (Number(eventInfo?.join_num) >= Number( eventInfo?.limit_member ) ) ){
                //キャンセル待ちをしていない　かつ　人数超過
                onClickCancelWaitingButton();
            }else{
            //　通常時
            onClickJoinButton();
            }
        }
    }

    const onClickLimitCancelButton= async() =>{
            let res = null;
            //  キャンセル登録
            res = await setCancel({
                loginId: loginId,
                paramId: paramId,
                eventUrl:eventUrl,
                rotaryCd: cookieRotaryCd.rotaryCookie
            });
            if(res !== null && res.result){
                setIsSend(true);
            }else{
                setIsError(true);
            }
    }
    
    const onClickCancelButton= async() =>{
        let res = null;
        if(limitCheck()){
            //  キャンセル失敗
            setIsError(true);
        }else{
            //  キャンセル登録
            res = await setCancel({
                loginId: loginId,
                paramId: paramId,
                eventUrl:eventUrl,
                rotaryCd: cookieRotaryCd.rotaryCookie
            });
            if(res.result){
                setIsSend(true);
            }else{
                setIsError(true);
            }
        }
    }

    const onClickUnJoinButton= async() =>{
        let res = null;
        if(limitCheck()){
            //  不参加登録失敗
            setIsError(true);
        }else{
            //  不参加登録
            res = await setNotJoin({
                loginId: loginId,
                paramId: paramId,
                eventUrl:eventUrl,
                rotaryCd: cookieRotaryCd.rotaryCookie
            });
            if(res !== null && res.result){
                setIsSend(true);
            }else{
                setIsError(true);
            }
        }
    }

    const onClickJoinButton= async() =>{
        let res =null;
        if(limitCheck()){
            // 参加登録失敗
            setIsError(true);    
        }else{
            //  参加登録
            res = await setJoin({
                loginId: loginId,
                paramId: paramId,
                eventUrl:eventUrl,
                rotaryCd: cookieRotaryCd.rotaryCookie
            });
            if(res !== null && res.result){
                setIsSend(true);
            }else{
                setIsError(true);
            }
        }
    }

    const onClickLimitCancelWaitingButton= async() =>{
        let res = null;
        //  キャンセル待ち登録
        res = await setCancelWaiting({
                loginId: loginId,
                paramId: paramId,
                eventUrl:eventUrl,
                rotaryCd: cookieRotaryCd.rotaryCookie
        });
        if(res !== null && res.result){
            setIsSend(true);
        }else{
            setIsError(true);
        }
    }

    const onClickCancelWaitingButton= async() =>{
        let res = null;
        if(limitCheck()){
            //  キャンセル待ち登録失敗
            setIsError(true);
        }else{
            //  キャンセル待ち登録
            res = await setCancelWaiting({
                loginId: loginId,
                paramId: paramId,
                eventUrl:eventUrl,
                rotaryCd: cookieRotaryCd.rotaryCookie
            });
            if(res !== null && res.result){
                setIsSend(true);
            }else{
                setIsError(true);
            }
        }
    }

    const limitCheck=()=>{
        let currentDateTime = new Date();
        let limitSet =false;

        const strLimitTime = eventInfo?.limit_time;
        var strLimitDate = new Date(eventInfo?.limit_date + '').toLocaleDateString();
        var limitDate = new Date(strLimitDate)

        if(limitDate && strLimitTime){
            //  hh:mm:ss
            const splitLimitTime = strLimitTime?.split(':')

            //  年月日をそれぞれ取得
            var limitHour = splitLimitTime[0]
            var limitMinute = splitLimitTime[1]
            var limitSecond = splitLimitTime[2]

            //  申込期限日に申込期限時刻を加算
            limitDate.setHours(limitDate.getHours() + Number(limitHour))
            limitDate.setMinutes(limitDate.getMinutes() + Number(limitMinute))
            limitDate.setSeconds(limitDate.getSeconds() + Number(limitSecond))

            //  現在日時と比較し、申込期限を過ぎている場合
            if(limitDate < currentDateTime){
                setLimit(true)
                limitSet = true;
            }
        }
        return limitSet;
    }


    return(
        <div className={`l-wrapper sp-view ${(isModal.modal) == true ? "is-modal" : ""} ${isSend == true ? "is-modal" : ""} `}>
            <main className="l-contents">
                <Header />
                <div className="l-default-content">
                    <div className="l-inner">
                        <div className="l-title">
                            <h2 className="title-txt">イベント詳細</h2>
                        </div>
                        { isError &&(
                            <div className="error-message-area">
                                <div className="message-box">
                                    <ul>
                                        <li>ただいまの登録は無効となります。</li>
                                    </ul>
                                </div>
                            </div>
                        )}					
                        <div className="l-record-wrap">
                            <EventDetail
                                detail={eventInfo??{ 
                                subject: "",
                                attachment_url: "",
                                mime_type: "",
                                icon_class: "",
                                event_type_name: "", 
                                date: "",  
                                from_time: "", 
                                to_time: "", 
                                limit_member: 0, 
                                location: "", 
                                member_fee: 0, 
                                limit_date: "",
                                limit_time: "",
                                reception_time:"",
                                phone_number:"",
                                contents:"",
                                place:"",
                                join_num: 0,
                                limit_date_join_num:0,
                                bank_branch:"",
                                transfer_method:"",
                                bank_account_address:"",
                                bank_account_name:"",
                                limit_bank_date:"",
                                limit_bank_time:"",
                                cancel_member_count: 0,
                                }}
                                isActive={isDetail}
                                setIsActive={setIsDetail}
                                attachments={attachments}
                            />

                            <div className="link-box">
                                <button 
                                    className="link-icon"
                                    onClick={() => changeModal({modal:true,joinORcancel:true})}
                                >
                                    参加予定の会員
                                
                                <i className="ic-member"><img src="img/ic_member.svg" alt="" /></i></button>
                            </div>
                            {(limit || Number(eventInfo?.join_num) >= Number( eventInfo?.limit_member )) &&
                                <div className="link-box">
							        <button 
                                        className="link-icon"
                                        onClick={() => changeModal({modal:true,joinORcancel:false})}>
                                            キャンセル待ちの会員
                                        <i className="ic-member"><img src="img/ic_member_w.svg" alt="" /></i>
                                     </button>
						        </div>
                            }
                            </div>
                        <form>
                            <div className="event-wrap">
                                <div className="form-are">
                                    <div className="form-set">
                                        <dl>
                                            <dt className="fsz-m1 fw-b">{loginName?.name}様</dt>
                                            { limit ? (
                                                 <dd>
                                                    期限切れのイベントです。<br></br>
                                                    {!joinInfo.cancel_waiting_flag ?
                                                    <>
                                                        {joinInfo.joinFlag ? '参加登録済みのイベントです。' : '不参加登録済みのイベントです。'}
                                                    </>
                                                    :
                                                    <>
                                                        {joinInfo.cancel_waiting_flag ? ('キャンセル待ちで登録しています。'):''} 
                                                    </>
                                                    }
                                                </dd>
                                                ) :(
                                                    (Number(eventInfo?.join_num) >= Number(eventInfo?.limit_member)) ?( 
                                                        <dd className="fsz-m1 fw-b">
                                                           <p className="fsz-m1">
                                                           参加可能人数を超えています。<br></br>
                                                            {!joinInfo.cancel_waiting_flag ?
                                                            <>
                                                                {joinInfo.joinFlag ? '参加登録済みのイベントです。' : '不参加登録済みのイベントです。'}
                                                            </>
                                                            :
                                                            <>
                                                                {joinInfo.cancel_waiting_flag ? ('キャンセル待ちで登録しています。'):''} 
                                                            </>
                                                            }
                                                           </p>
                                                        </dd>
                                                    ):(
                                                        <dd className="fsz-m1 fw-b">
                                                           <p className="fsz-m1">
                                                              {joinInfo.joinFlag ? '参加登録済みのイベントです。' : '不参加登録済みのイベントです。'}
                                                           </p>
                                                        </dd>
                                                    )
                                                )
                                            }
                                        </dl>
                                    </div>
                                </div>
                                {/* 申込期限切れか否か */}
                                { limit ? (
                                    // 期限切れ
                                    !joinInfo.cancel_waiting_flag &&  (
                                        // キャンセル待ちしてない
                                    <div className="btn-area flex-column col1">
                                        <div className="record-notice">
									        <span className="stxt">このイベントは期限切れです。
                                                {joinInfo.joinFlag && "キャンセル後は再申し込みできません。"}
                                            </span>
								        </div>
                                        <button 
                                            type="button"
                                            className={`${joinInfo.joinFlag ? 'btn-main': 'btn-sub'}  btnsz-l`}
                                            onClick={() => {onClickButton()}}>
                                            {joinInfo.joinFlag ? 'キャンセル': 'キャンセル待ち'}
                                        </button>
                                    </div>
                                )):(
                                    // 期限内
                                    (Number(eventInfo?.join_num) >= Number(eventInfo?.limit_member) ? (
                                        // 人数超過
                                        !joinInfo.cancel_waiting_flag &&(
                                            // キャンセル待ちしてない
                                        <div className="btn-area flex-column col1">
                                            <div className="record-notice">
									        <span className="stxt">このイベントは参加可能人数を超えたため締め切っています。
                                                {joinInfo.joinFlag && "キャンセル後は再申し込みできません。"}
                                            </span>
								        </div>
                                        <button 
                                            type="button"
                                            className={`${joinInfo.joinFlag ? 'btn-main': 'btn-sub'}  btnsz-l`}
                                            onClick={() => {onClickButton()}}>
                                            {joinInfo.joinFlag ? 'キャンセル': 'キャンセル待ち'}
                                        </button>
                                    </div>
                                    )):(
                                        // 定員内（通常時）
                                        <div className="btn-area flex-column col1">
                                        <button 
                                            type="button"
                                            className="btn-main btnsz-l"
                                            onClick={() => {onClickButton()}}>
                                            {joinInfo.joinFlag ? 'キャンセル': '参加'}
                                        </button>
                                    </div>
                                    ))
                                )}
                            </div>
                        </form>

                    </div>
                </div>
                
                {/**参加予定の会員　モーダル */}
                {isModal.modal && (
                    isModal.joinORcancel && (
                    <JoinUsersList 
                        users={joinUsers} 
                        onClick={() => changeModal({modal:false,joinORcancel:true})}
                    /> 
                    )
                )}

                {/* キャンセル待ち登録の会員　モーダル */}
                {isModal.modal &&
                !isModal.joinORcancel &&(
                    <CancelWaitUsersList
                        users={cancelWaitingUsers}
                        onClick={() => changeModal({modal:false,joinORcancel:false})}
                    />
                    )
                }
                   
                {/**メール送信完了モーダル */}
                {isSend &&
                    <MailSendedModal
                        more_flag={isMore}
                    />
                }

            </main>
            <Footer />
        </div>
    );
}